import { Component, Input, OnInit } from '@angular/core';
import { LeftpanelComponent, LoaderWithProgressComponent } from '../leftpanel/leftpanel.component';
import { ConfService } from '../conf.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';

@Component({
    selector: 'app-data-analytics-new',
    templateUrl: './data-analytics-new.component.html',
    styleUrls: ['./data-analytics-new.component.scss']
})
export class DataAnalyticsNewComponent implements OnInit {
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    @Input() partnerKey = localStorage.getItem('partnerKey');
    planName = '';
    version = '';
    category = '';
    description = '';
    componentLoading = true;
    dbConnections: any = [];
    selectedDbConnection: any;
    databases: any = [];
    selectedDatabase: any;
    tables: any = [];
    selectedTables: any;

    constructor(public platform: LeftpanelComponent, private confPost: ConfService,
        public router: Router, public dialog: MatDialog) {
    }

    ngOnInit() {
        if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
            this.platform.initialisePlatform();
        }
        this.getDbConnections();
    }

    getDbConnections() {
        this.componentLoading = true;
        this.confPost.getDatabasesForPartner(this.partner, this.partnerKey).subscribe(data => {
            const res: any = data;
            // console.log(res);
            if (res) {
                // this.dbConnections = res.body;
                for (const db of res.body) {
                    if (db.database_type == 'mysql' || db.database_type == 'sqlserver') {
                        this.dbConnections.push(db);
                    }
                }
                this.componentLoading = false;
            }

        }, err => {
            this.platform.handleErrorGracefully(err, 'Error while retrieving database connections.');
            this.componentLoading = false;
            this.router.navigateByUrl('/data-analytics');
        });
    }

    getDatabases() {
        if (this.selectedDbConnection) {
            this.confPost.getDatabasesForAConnection(this.partner, this.selectedDbConnection['database_name'], this.selectedDbConnection['database_type']).subscribe(data => {
                const res: any = data;
                // console.log(res);
                if (res) {
                    this.databases = res;
                    this.selectedDatabase = undefined;
                    this.selectedTables = undefined;
                }

            }, err => {
                this.platform.handleErrorGracefully(err, 'Error while retrieving databases.');
            });
        }
    }

    getTables() {
        if (this.selectedDatabase) {
            this.confPost.getDatabaseTablesForAConnection(this.partner, this.selectedDbConnection['database_name'], this.selectedDbConnection['database_type'], this.selectedDatabase).subscribe(data => {
                const res: any = data;
                if (res) {
                    this.tables = res;
                }

            }, err => {
                this.platform.handleErrorGracefully(err, 'Error while retrieving tables.');
            });
        }
    }


    deploy() {
        if (this.planName !== '' && this.version !== '') {
            if (this.selectedDbConnection) {
                if (this.selectedDatabase) {
                    if (this.selectedTables) {
                        const payload = {
                            "planName": this.planName,
                            "databaseName": this.selectedDatabase,
                            "databaseConnectionName": this.selectedDbConnection.database_name,
                            "partner": this.partner,
                            "databasetype": this.selectedDbConnection.database_type,
                            "pkey": this.partnerKey,
                            "tables": this.selectedTables
                        };
                        // console.log(payload);
                        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
                            maxWidth: '95vw',
                            maxHeight: '60vh',
                        });
                        this.confPost.postDataAnalyticsPlan(payload).subscribe(res => {
                            loaderDialog.close();
                            this.router.navigateByUrl('/data-analytics');
                        }, err => {
                            loaderDialog.close();
                            this.platform.handleErrorGracefully(err, 'Error while adding data analytics plan');
                        });

                    } else {
                        this.platform.handleErrorGracefully('', 'Please select atleast one table');
                    }
                } else {
                    this.platform.handleErrorGracefully('', 'Please select database');
                }
            } else {
                this.platform.handleErrorGracefully('', 'Please select database connection');
            }
        } else {
            this.platform.handleErrorGracefully('', 'Please enter all the required fields');
        }
    }

}
